import {ListProductDetailImage} from './list-product-detail-image';
import {ProductInfo} from './product-info';
import {ProductDetailCollapse} from './product-detail';
import {ListProductOther} from './list-product-other';
import {ListProduct} from './list-product';

export {
  ListProductDetailImage,
  ProductInfo,
  ProductDetailCollapse,
  ListProductOther,
  ListProduct
}


// WEBPACK FOOTER //
// ./components/product-detail/sub-view/index.js